import { Component, Input, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-header-progress-bar',
  templateUrl: './header-progress-bar.component.html',
  styleUrls: ['./header-progress-bar.component.scss'],
})
export class HeaderProgressBarComponent implements OnInit {

  @Input() screens = Array.from({ length: 30 });
  @Input() currentIndex = 0
  constructor(public platform: Platform) {
   }

  ngOnInit() {
  }
}
